import { Button, Card, Chip, Grid, Typography } from '@mui/material';
import { IconFlag } from '@tabler/icons-react';
import { PiFlagBanner } from 'react-icons/pi';
import { initial_formAddNewDomain, setShowScanDomainDialog } from 'src/store/my_pages/app';
import { dispatch } from 'src/store/Store';

const NoDomainAddedInfoCard = () => {
  return (
    <Grid container spacing={1} mt={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Grid
        size={{
          xs: 12,
          lg: 7
        }}>
        <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
          <Chip
            label=""
            sx={{
              bgcolor: (theme) => theme.palette.primary.main,
              color: 'white',
              borderRadius: '10rem',
              width: 55,
              minWidth: 55,
              height: 55,
              '& > svg': {
                padding: 0,
                width: 31,
                minWidth: 31,
                height: 31,
                position: 'relative',
                left: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              },
            }}
            size="small"
            // label="Medium"
            // icon={<IconFlag color="white" size={28} />}
            icon={<PiFlagBanner  color="white" size={28} />}
          />
          <Typography fontSize={16} fontWeight={400}>
            Add a URL to get started.
          </Typography>
          <Typography component="p" variant="body1">
            If you would like to add a new target, simply click the add button to get started :
          </Typography>
          <Button sx={{ width: 'fit-content', color: 'white' }} color="primary" variant="contained" fullWidth onClick={() => dispatch(setShowScanDomainDialog(initial_formAddNewDomain))}>
            Add a domain
          </Button>
        </Card>
      </Grid>
    </Grid>
  );
};

export default NoDomainAddedInfoCard;
